<svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#filter0_d_6882_1597)">
<circle cx="40" cy="40" r="36" fill="url(#paint0_linear_6882_1597)"/>
<g filter="url(#filter1_ddd_6882_1597)">
<circle cx="39.9999" cy="40" r="31.7333" fill="url(#paint1_linear_6882_1597)"/>
</g>
<g filter="url(#filter2_dd_6882_1597)">
<circle cx="40.0001" cy="40" r="27.4667" fill="url(#paint2_linear_6882_1597)"/>
<circle cx="40.0001" cy="40" r="25.8667" stroke="url(#paint3_linear_6882_1597)" stroke-width="3.2"/>
</g>
</g>
<g filter="url(#filter3_d_6882_1597)">
<path d="M38.3645 25.5153C39.2172 24.4971 40.7829 24.4971 41.6355 25.5153L52.619 38.6303C53.2828 39.4228 53.2828 40.5772 52.619 41.3697L41.6355 54.4847C40.7829 55.5028 39.2172 55.5028 38.3645 54.4847L27.381 41.3697C26.7173 40.5772 26.7173 39.4228 27.381 38.6303L38.3645 25.5153Z" fill="#D9D9D9"/>
<path d="M38.3643 25.5153C38.7906 25.0064 39.3949 24.7518 39.9993 24.7517C39.9993 27.8467 39.9993 40.0035 39.9993 40.0035C39.9993 40.0035 38.3643 39.9997 26.8831 39.9997C26.8831 39.5131 27.0491 39.0265 27.3809 38.6303L38.3643 25.5153Z" fill="url(#paint4_linear_6882_1597)"/>
<path d="M38.3643 54.4916C38.7906 55.0006 39.3949 55.2551 39.9993 55.2552C39.9993 52.1602 39.9993 40.0035 39.9993 40.0035C39.9993 40.0035 38.3643 40.0072 26.8831 40.0072C26.8831 40.4938 27.0491 40.9805 27.3809 41.3767L38.3643 54.4916Z" fill="url(#paint5_linear_6882_1597)"/>
<path d="M41.6344 25.5153C41.2082 25.0064 40.6039 24.7518 39.9994 24.7517C39.9994 27.8467 39.9994 40.0035 39.9994 40.0035C39.9994 40.0035 41.6344 39.9997 53.1157 39.9997C53.1157 39.5131 52.9497 39.0265 52.6179 38.6303L41.6344 25.5153Z" fill="url(#paint6_linear_6882_1597)"/>
<path d="M41.6344 54.4916C41.2082 55.0006 40.6039 55.2551 39.9994 55.2552C39.9994 52.1602 39.9994 40.0035 39.9994 40.0035C39.9994 40.0035 41.6344 40.0072 53.1157 40.0072C53.1157 40.4938 52.9497 40.9805 52.6179 41.3767L41.6344 54.4916Z" fill="url(#paint7_linear_6882_1597)"/>
</g>
<g style="mix-blend-mode:color">
<circle cx="40" cy="40" r="36" fill="white"/>
</g>
<defs>
<filter id="filter0_d_6882_1597" x="1.62667" y="2.69333" width="76.7467" height="76.7467" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="1.06667"/>
<feGaussianBlur stdDeviation="1.18667"/>
<feComposite in2="hardAlpha" operator="out"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_6882_1597"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_6882_1597" result="shape"/>
</filter>
<filter id="filter1_ddd_6882_1597" x="6.15993" y="6.16" width="68.5866" height="67.7867" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="1.05333"/>
<feComposite in2="hardAlpha" operator="out"/>
<feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_6882_1597"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="1.06667" dy="0.266667"/>
<feGaussianBlur stdDeviation="0.973333"/>
<feComposite in2="hardAlpha" operator="out"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"/>
<feBlend mode="normal" in2="effect1_dropShadow_6882_1597" result="effect2_dropShadow_6882_1597"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="1.06667"/>
<feGaussianBlur stdDeviation="0.533333"/>
<feComposite in2="hardAlpha" operator="out"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"/>
<feBlend mode="normal" in2="effect2_dropShadow_6882_1597" result="effect3_dropShadow_6882_1597"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect3_dropShadow_6882_1597" result="shape"/>
</filter>
<filter id="filter2_dd_6882_1597" x="10.0534" y="10.0533" width="59.8934" height="59.8934" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="1.24"/>
<feComposite in2="hardAlpha" operator="out"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.21 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_6882_1597"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="0.533333"/>
<feGaussianBlur stdDeviation="0.733333"/>
<feComposite in2="hardAlpha" operator="out"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.26 0"/>
<feBlend mode="normal" in2="effect1_dropShadow_6882_1597" result="effect2_dropShadow_6882_1597"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_6882_1597" result="shape"/>
</filter>
<filter id="filter3_d_6882_1597" x="24.7497" y="23.1517" width="30.5006" height="34.7702" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="0.533333"/>
<feGaussianBlur stdDeviation="1.06667"/>
<feComposite in2="hardAlpha" operator="out"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_6882_1597"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_6882_1597" result="shape"/>
</filter>
<linearGradient id="paint0_linear_6882_1597" x1="4" y1="4" x2="75.7555" y2="76.2428" gradientUnits="userSpaceOnUse">
<stop stop-color="#C8CACC"/>
<stop offset="1" stop-color="#92969A"/>
</linearGradient>
<linearGradient id="paint1_linear_6882_1597" x1="8.2666" y1="8.26666" x2="71.5178" y2="71.9474" gradientUnits="userSpaceOnUse">
<stop stop-color="#7D8286"/>
<stop offset="1" stop-color="#C8CACC"/>
</linearGradient>
<linearGradient id="paint2_linear_6882_1597" x1="19.4192" y1="19.4191" x2="67.4668" y2="67.4667" gradientUnits="userSpaceOnUse">
<stop stop-color="#C8CACC"/>
<stop offset="1" stop-color="#5A6066"/>
</linearGradient>
<linearGradient id="paint3_linear_6882_1597" x1="19.4192" y1="19.4191" x2="69.6283" y2="69.6282" gradientUnits="userSpaceOnUse">
<stop stop-color="#A8ABAE"/>
<stop offset="1" stop-color="#5A6066"/>
</linearGradient>
<linearGradient id="paint4_linear_6882_1597" x1="26.8831" y1="24.7517" x2="33.593" y2="39.9562" gradientUnits="userSpaceOnUse">
<stop stop-color="#A8ABAE"/>
<stop offset="1" stop-color="#E9EAEA"/>
</linearGradient>
<linearGradient id="paint5_linear_6882_1597" x1="28.5767" y1="51.0621" x2="43.0067" y2="43.7244" gradientUnits="userSpaceOnUse">
<stop stop-color="#7D8286"/>
<stop offset="1" stop-color="#C8CACC"/>
</linearGradient>
<linearGradient id="paint6_linear_6882_1597" x1="55.2649" y1="35.6809" x2="42.0235" y2="29.2392" gradientUnits="userSpaceOnUse">
<stop stop-color="#C8CACC"/>
<stop offset="1" stop-color="#A8ABAE"/>
</linearGradient>
<linearGradient id="paint7_linear_6882_1597" x1="51.8015" y1="48.8211" x2="35.0822" y2="40.6571" gradientUnits="userSpaceOnUse">
<stop stop-color="#C8CACC"/>
<stop offset="1" stop-color="#5A6066"/>
</linearGradient>
</defs>
</svg>
